export const tokenAddresses = {
  EUL: "0xDe1763aFA5eB658CfFFfD16835AfeB47e7aC0B8D",
  eUSD: "0x0000000000000000000000000000000000000000",
  rEUL: "0x9f395F610Af9ffC98693A0769190446180dc7192",
  seUSD: "0x0000000000000000000000000000000000000000",
} as const
